var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5H8.33333C6.49167 5 5 6.49167 5 8.33333V31.6667C5 33.5083 6.49167 35 8.33333 35H31.6667C33.5083 35 35 33.5083 35 31.6667V8.33333C35 6.49167 33.5083 5 31.6667 5ZM15 28.3333H10.795V16.6667H15V28.3333ZM12.8233 14.5283C11.5383 14.5283 10.68 13.6717 10.68 12.5283C10.68 11.385 11.5367 10.5283 12.965 10.5283C14.25 10.5283 15.1083 11.385 15.1083 12.5283C15.1083 13.6717 14.2517 14.5283 12.8233 14.5283ZM30 28.3333H25.93V21.9567C25.93 20.1933 24.845 19.7867 24.4383 19.7867C24.0317 19.7867 22.675 20.0583 22.675 21.9567C22.675 22.2283 22.675 28.3333 22.675 28.3333H18.47V16.6667H22.675V18.295C23.2167 17.345 24.3017 16.6667 26.3367 16.6667C28.3717 16.6667 30 18.295 30 21.9567V28.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.eaded382c95931418a81ca5d2cadbdc9.svg";
export { ForwardRef as ReactComponent };